module.exports = "<!-- Copyright (C) 2016 NooBaa -->\n\n<svg-icon params=\"name: icon\" ko.css=\"css\" ko.visible=\"visible\"></svg-icon>\n";
